<template>
    <div class="container">
        <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
            <el-form ref="form"  :inline="true" style="margin:20px 0;">
                <el-row type="flex" class="row-bg" justify="center">
                        <el-col :span="6">
                            <div class="moneyInfo">
                                <p>100.00</p>
                                <p>营销经费余额</p>
                                <p @click="recharge">立即充值</p>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="moneyInfo">
                                <p>100.00</p>
                                <p>已发放金额</p>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="moneyInfo">
                                <p>200.00</p>
                                <p>累计充值金额</p>
                            </div>
                        </el-col>
                </el-row>
            </el-form>
            <!-- 红包发放明细 -->
            <el-tab-pane label="红包发放明细" name="first">
                    <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
                        <el-form-item label="添加时间:" style="text-align: center">
                        <el-col :span="11">
                            <el-date-picker type="date" placeholder="开始时间" v-model="start_time"
                            style="width: 100%;"></el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-date-picker type="date" placeholder="结束时间" v-model="end_time"
                                style="width: 100%;"></el-date-picker>
                        </el-col>
                        </el-form-item>
                        <el-form-item label="发放应用:">
                            <el-select v-model="form1.from_level_id"  clearable @change="selectType">
                                <el-option key="" label="全部" value=""></el-option>
                                <el-option v-for=" i in staffType" :key="i.id" :label="i.type_name"
                                        :value="i.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="发放openid:">
                            <el-input v-model="form1.staff_keyword" clearable ></el-input>
                        </el-form-item>
                        <el-form-item label="红包ID:">
                            <el-input v-model="form1.staff_keyword" clearable ></el-input>
                        </el-form-item>
                        <el-form-item label="活动ID:">
                            <el-input v-model="form1.staff_keyword" clearable ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="getPointsList()">搜索</el-button>
                            <el-button type="primary" @click="dealerExport()">导出</el-button>
                        </el-form-item>
                    </el-form>
                    <!--红包发放明细表格-->
                    <el-table
                            ref="multipleTable"
                            :data="tableData1"
                            v-loading="loading"
                            border
                            stripe
                            style="width: 100%;margin: 20px">
                        <el-table-column
                                prop="staff_sn"
                                label="ID"
                                fixed>
                        </el-table-column>
                        <el-table-column
                                prop="staff_name"
                                label="时间"
                                width="220"
                                >
                                <template slot-scope="scope">
                                    <span style="color:#529FF0;cursor: pointer" @click="detail(scope.row)">{{scope.row.staff_name}}</span>
                                </template>
                        </el-table-column>

                        <el-table-column
                                prop="mobile"
                                label="发放金额"
                                show-overflow-tooltip>
                        <!-- <template slot-scope="scope">
                            <span v-if="scope.row.from_type == 1">总部</span>
                            <span v-if="scope.row.from_type == 2">经销商</span>
                            <span v-if="scope.row.from_type == 3">门店</span>
                            </template>-->
                        </el-table-column>
                        <el-table-column
                                prop="type_name"
                                label="发放后余额"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="openid"
                                label="openid"
                                width="220"
                                show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <el-popover trigger="hover" placement="right" width='300'>
                                            <div style='margin-bottom:15px;position: relative;'>
                                                <img src="../../../src/assets/img/2.png" alt="" style="width:60px;height:60px;">
                                                <span style="transform: translte(-50%,-23%);position: absolute;top: 50%;left:23%;">微信昵称:xx</span>
                                             </div>
                                            <div style='margin-bottom:15px'>姓名: scope.row.name </div>
                                            <div style='margin-bottom:15px'>客户ID: 132</div>
                                            <div style='margin-bottom:15px'>OpenId: 12233</div>
                                            <div style='margin-bottom:15px'>手机号: 132556555</div>
                                        <div slot="reference" >
                                            {{ scope.row.openid }}
                                        </div>
                                    </el-popover>
                                </template>
                        </el-table-column>
                        <el-table-column
                                prop="type_name"
                                label="发放应用(活动主题-ID)"
                                width="220"
                                show-overflow-tooltip>
                        </el-table-column>
                        
                        <el-table-column
                                prop="status"
                                label="红包ID"
                                show-overflow-tooltip>         
                        </el-table-column>
                    </el-table>
                    <!--分页-->
                    <el-pagination
                            style="margin: 20px 0"
                            @size-change="handleSizeChange1"
                            @current-change="handleCurrentChange1"
                            :current-page="pageNo1"
                            :page-sizes="[20, 50, 100, 200]"
                            :page-size="pageSize1"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalSize1">
                    </el-pagination>
            </el-tab-pane>
            <!-- 充值记录 -->
            <el-tab-pane label="充值记录" name="second">
                <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
                       <el-form-item label="添加时间:" style="text-align: center">
                            <el-col :span="11">
                                <el-date-picker type="date" placeholder="开始时间" v-model="start_time"
                                style="width: 100%;"></el-date-picker>
                            </el-col>
                            <el-col class="line" :span="2">-</el-col>
                            <el-col :span="11">
                                <el-date-picker type="date" placeholder="结束时间" v-model="end_time"
                                    style="width: 100%;"></el-date-picker>
                            </el-col>
                        </el-form-item>
                        <el-button type="primary" @click="getPointsChangeList()">搜索</el-button>
                        <el-button type="primary" @click="dealerExport2()">导出</el-button>
                </el-form>
                <!-- 充值记录表格 -->
                <el-table
                         ref="multipleTable"
                            :data="tableData2"
                            v-loading="loading"
                            border
                            stripe
                            style="width: 100%;margin: 20px">
                    <el-table-column
                            label="充值时间"
                            prop="staff_sn"
                            fixed
                    >
                    </el-table-column>
                    <el-table-column
                            prop="staff_name"
                            label="充值金额"
                            fixed>
                    </el-table-column>
                    <el-table-column
                            prop="mobile"
                            label="充值后余额"
                            show-overflow-tooltip>
                    </el-table-column>
                </el-table>
                <!--分页-->
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :current-page="pageNo2"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pageSize2"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize2">
                </el-pagination>
            </el-tab-pane>
        </el-tabs>
        <!-- 增加积分 -->
        <el-dialog :title="formTitle" :visible.sync="dialogFormVisible">
            <el-form :model="form">
                 <el-form-item label="员工：" label-width="120px">
                   <span>{{staff_sn}}</span>
                </el-form-item>
                <el-form-item label="积分类型" label-width="120px" style="position: relative;">
                        <span style="position: absolute;left: -77px;top: 0;right: 0;color: red;">*</span>
                        <el-select v-model="pointsName"  clearable @change="selectPontsType">
                            <el-option v-for=" i in pointsType" :key="i.point_type_sn" :label="i.point_type_name"
                                       :value="i.point_type_sn"></el-option>
                        </el-select>
                    <el-button type="primary" @click="refresh" style="margin:0 10px;z-index: 999999;position: relative;">刷新</el-button>
                    <div style="color:rgb(51, 162, 151);z-index: 999999;position: relative;display: inline-block;cursor: pointer;" @click="addPointType">添加积分类型</div>
                </el-form-item>
                <el-form-item label="积分事项" label-width="120px" v-show="pointsMatterArr2.length!==0" >
                    <el-select v-model="pointsMatterName"  clearable @change="selectPontsMatterType" @visible-change='pointMatter'>
                            <el-option v-for=" i in pointsMatterArr2" :key="i.option_id" :label="i.option_name"
                                       :value="i.option_id"></el-option>
                    </el-select>
                    <span>&nbsp;&nbsp;可不选，用于记录增加积分原因</span>
                </el-form-item>
                <el-form-item :label="labelTtile" label-width="80px" style="position: relative;">
                    <span style="position: absolute;left: -77px;top: 0;right: 0;color: red;">*</span>
                    <el-input v-model="point_num" autocomplete="off" type='text' maxlength="6" style="width:90%;"></el-input>
                    <span>&nbsp;&nbsp;分</span>
                </el-form-item>
                <el-form-item label="备注" label-width="80px">
                    <el-input style="width:90%;"
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 4}"
                        placeholder="选填"
                        v-model="remarks" maxlength='50'>
                    </el-input>
                    <span>&nbsp;&nbsp;(0/50)</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirm_btn">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 积分明细 -->
        <el-dialog title="明细" :visible.sync="integralInfoShow">
            <!-- <el-dialog
            width="30%"
            title="内层 Dialog"
            :visible.sync="innerVisible"
            append-to-body>
            </el-dialog> -->
            <integral-detail :staff_sn='staff_sn'></integral-detail>
        </el-dialog>
        <!-- 员工详情 -->
        <el-dialog title="查看详情" :visible.sync="staffShow">
            <el-form :model="form">
                <el-form-item label="员工编号:" label-width="80px" style="position: relative;">
                    <p>{{staffInfo.staff_sn}}</p>
                </el-form-item>
            </el-form>
            <el-form :model="form">
                <el-form-item label="员工姓名:" label-width="80px" style="position: relative;">
                    <p>{{staffInfo.staff_name}}</p>
                </el-form-item>
            </el-form>
            <el-form :model="form">
                <el-form-item label="手机号:" label-width="80px" style="position: relative;">
                    <p>{{staffInfo.mobile}}</p>
                </el-form-item>
            </el-form>
            <el-form :model="form">
                <el-form-item label="员工类型:" label-width="80px" style="position: relative;">
                    <p>{{staffInfo.staff_sn}}</p>
                </el-form-item>
            </el-form>
            <el-form :model="form">
                <el-form-item label="管理范围:" label-width="80px" style="position: relative;">
                    <ul>
                        <li v-for="(item,index) in staffInfo.region" :key="'item'+index">{{item.description}}</li>
                    </ul>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <!-- <el-button @click="staffShow = false">取 消</el-button> -->
            </div>
        </el-dialog>
        <!--选择经销商-->
        <!-- <selectDealer
                v-if="selectDealerDialog"
                v-on:handleClose='selectDealerDialog = false'
                @pushData="getDealerInfo">
        </selectDealer> -->
        <!--窜货经销商统计明细-->
        <!-- <dealerCountDetail
                v-if="dealerCountDetailDialog"
                v-on:handleClose='dealerCountDetailDialog = false'
                :dealerData="dealerData"
        >
        </dealerCountDetail> -->
        <!--窜货商品统计-->
        <!-- <productCountDetail
                v-if="productCountDetailDialog"
                v-on:handleClose='productCountDetailDialog = false'
                :productData="productData"
        >
        </productCountDetail> -->
    </div>
</template>
<script>
    // import selectDealer from '../../common/selectDealer';
    // import dealerCountDetail from './dealerCountDetail';
    // import productCountDetail from './productCountDetail';
    // import IntegralDetail from './integralDetail';
    // import importData from './importData';
    export default {
        components: {
            // IntegralDetail,
            // importData
        },
        name: "fleeing-count",
        data() {
            return {
                staffShow:false,
                pointTypeName:"",
                point_num:"",
                pointsName:"",
                pointsName2:"",
                staff_num:"",
                staffType:[],
                textarea2:"",
                integralInfoShow:false,
                formTitle:"",
                labelTtile:"",
                remarks:"",
                pointsMatterArr2:[],
                pointsMatterName2:"",
                pointTypeName2:"",
                staffInfo:{
                    staff_sn:"",
                    staff_name:"",
                    is_region:"",
                    mobile:"",
                    type_name:"",
                    region:[]
                },
                // statusArr:[
                //     {
                //         id:1,
                //         name:'正常'
                //     },
                //     {
                //         id:2,
                //         name:'已禁用'
                //     },
                //     {
                //         id:3,
                //         name:'已删除'
                //     }
                // ],
                form: {
                    name: '',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: ''
                },
                dialogFormVisible:false,
                loading:false,
                selectDealerDialog: false,
                dealerCountDetailDialog: false,
                productCountDetailDialog: false,
                activeName2: 'first',
                form1: {
                    from_sn: '',
                    staff_keyword: '',
                    from_level_id: '',
                    status:"",
                },
                form2: {
                    keywords: ''
                },
                tableData:[],
                tableData1: [{
                    openid:'oshuibnknkhbOWhljljhl'
                }],
                tableData2: [],
                tableObj:{},
                //分页
                pageNo1: 1,//页码
                pageSize1: 20,//每页现实的条数
                totalSize1: 0,//总条数
                //分页
                pageNo2: 1,//页码
                pageSize2: 20,//每页现实的条数
                totalSize2: 0,//总条数
                dealerLevel: [],//经销商级别
                dealerData: {},
                productData: {},
                staff_type_id:"",
                staffStatus:"",
                point_type:"",
                staff_sn:"",
                pointsType:[],
                point_type_sn:"",
                pointsMatterName:"",
                pointsMatterArr:[],
                option_id:"",
                point_type:"",
                start_time:"",
                end_time:"",
                totol_sub_point:"",
                totol_add_point:"",
                tab:{
                    label:"积分管理"
                },
                pointArr:[
                    {
                      id:1,
                      type_name:'增加'
                    },
                    {
                      id:2,
                      type_name:'扣减'
                    }
                ],
            }
        },
        methods:{
                recharge() {
                    this.$alert('请联系总部充值','提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        // this.$message({
                        // type: 'info',
                        // message: `action: ${ action }`
                        // });
                    }
                    });
                },
                //员工详情
                detail(row){
                    // this.staff_sn = row.staff_sn;
                    this.staffShow = true;
                    this.$get(this.global + `/staffs/${row.staff_sn}`).then(res => {
                        this.staffInfo.staff_sn = res.data.staff_sn;
                        this.staffInfo.staff_name = res.data.staff_name;
                        this.staffInfo.mobile = res.data.mobile;
                        this.staffInfo.region = res.data.region;
                    }).catch(error=>{
                        console.log(error);
                    });
                },
                refresh(){
                    this.pointsName = '';
                    this.pointsMatterName = '';
                    this.getPointsTypeList();
                },
                selectType2(val){
                    this.point_type = val;
                },
                addPointType(){
                    this.$router.push({name:'integralTypeManage'});
                },
                pointMatter(){
                    if(this.pointsName==''){
                        this.$message({
                            type: 'warning',
                            message: '请先选择积分类型'
                        });
                    }
                    return;
                },
                selectPontsMatterType(val){
                    this.option_id = val;
                },
                selectPontsType(val){
                    this.point_type_sn = val;
                    this.getPointsMatterTypeList();
                },
                selectStatus(val){
                    this.staffStatus = val;
                },
                selectType(val){
                    this.staff_type_id = val;
                },
                handleSelectionChange(){},
                getLastMonth() {
                    var now = new Date();
                    var year = now.getFullYear();//getYear()+1900=getFullYear()
                    var month = now.getMonth() + 1;//0-11表示1-12月
                    var day = now.getDate();
                    var dateObj = {};
                    if (parseInt(month) < 10) {
                        month = "0" + month;
                    }
                    if (parseInt(day) < 10) {
                        day = "0" + day;
                    }
                    dateObj.now = year + '-' + month + '-' + day;
                    if (parseInt(month) == 1) {//如果是1月份，则取上一年的12月份
                        dateObj.last = (parseInt(year) - 1) + '-12-' + day;
                        return dateObj;
                    }
                    var preSize = new Date(year, parseInt(month) - 1, 0).getDate();//上月总天数
                    if (preSize < parseInt(day)) {//上月总天数<本月日期，比如3月的30日，在2月中没有30
                        dateObj.last = year + '-' + month + '-01';
                        return dateObj;
                    }

                    if (parseInt(month) <= 10) {
                        dateObj.last = year + '-0' + (parseInt(month) - 1) + '-' + day;
                        return dateObj;
                    } else {
                        dateObj.last = year + '-' + (parseInt(month) - 1) + '-' + day;
                        return dateObj;
                    }
                },
                //选择经销商
                getDealerInfo(val) {
                    this.form1.from_sn = val.dealer_sn;
                    this.form1.dealer_name = val.dealer_name;
                },
                //获取积分类型事项列表
                getPointsMatterTypeList(){
                    this.$get(this.global + `/points.types/${this.point_type_sn}/options`, {
                        lang: '',
                    }).then(res => {
                        this.pointsMatterArr2 = res.data;
                        // this.totalSize1 = res.meta.total;
                    }).catch(error=>{
                        console.log(error);
                    });
                },
                //获取积分类型列表
                getPointsTypeList() {
                    this.loading = true;
                    this.$get(this.global + '/points.types', {
                        lang: '',
                    }).then(res => {
                        this.loading = false;
                        this.pointsType = res.data;
                        // this.totalSize1 = res.meta.total;
                    }).catch(error=>{
                        this.loading = false;
                        console.log(error);
                    });
                },
                //获取积分列表
                getPointsList() {
                    this.loading = true;
                    this.$get(this.global + '/points', {
                        lang: '',
                        per_page: this.pageSize1,
                        page: this.pageNo1,
                        keyword:this.form1.staff_keyword,
                        staff_type_id:this.staff_type_id,
                        status:this.staffStatus
                    }).then(res => {
                        this.loading = false;
                        for(var i = 0;i<res.data.length;i++){
                            for(var j = 0;j<res.data[i].point_types.length;j++){
                                res.data[i][res.data[i].point_types[j].point_type_sn]=res.data[i].point_types[j]
                            }
                        }
                        // this.tableData1 = res.data;
                        this.totalSize1 = res.meta.total;
                    }).catch(error=>{
                        this.loading = false;
                        console.log(error);
                    });
                },
                // 获取员工类型
                getStaffstype(){
                    this.loading = true;
                    this.$get(this.global + '/staffs.types',{
                        per_page: this.pageSize1,
                        page: this.pageNo1,
                    }).then(res => {
                        this.staffType = res.data;
                    }).catch(function (error) {
                        console.log(error);
                    });
                    // this.$get('logistics', '/staffs.types', {
                    //     per_page: this.pageSize1,
                    //     page: this.pageNo1,
                    // }).then(res => {
                    //     this.staffType = res.data;
                    // }).catch(error=>{
                    //     console.log(error);
                    // });
                },
                //导出
                dealerExport(){
                    var access_tokens = '';
                    access_tokens = localStorage.getItem('access_tokens');
                    window.open(this.global
                        +'/points.export?staff_type_id=' + this.staff_type_id+'&is_export=1' +'&status=' + this.staffStatus+'&keyword=' + this.form1.staff_keyword+'&lang=' + ''+'&signature='+ this.$md5(access_tokens)
                    )
                },
                //导出
                dealerExport2(){
                    var access_tokens = '';
                    access_tokens = localStorage.getItem('access_tokens');
                    window.open(this.global
                        +'/points/logs.export?staff_type_id=' + this.staff_type_id+'&is_export=1'+'&start_time=' + this.start_time+'&end_time=' + this.end_time +'&option_id=' + this.option_id+'&point_type_sn=' + this.point_type_sn+'&point_type=' + this.point_type+'&keyword=' + this.form1.staff_keyword+'&lang=' + ''+'&signature='+ this.$md5(access_tokens)
                    )
                },
                //导出
                productExport(){
                    let url = '',access_tokens = localStorage.getItem('access_tokens');
                    if(process.env.NODE_ENV == 'development'){
                        url = 'http://logistics.c.';
                    }else if(process.env.NODE_ENV == 'production'){
                        url = 'http://logistics.';
                    }else{
                        url = 'http://logistics.c.';
                    }

                    window.open(url+process.env.VUE_APP_URL
                        +'/feelinggoods/products.export?keywords=' + this.form2.keywords +'&is_export=1'+ '&lang=' + ''+'&signature='+ this.$md5(access_tokens)
                    )
                },
                //选择经销商
                // selectDealer() {
                //     this.selectDealerDialog = true;
                // },
                confirm_btn(){
                    if(this.pointsName==''){
                        this.$message({
                            type: 'warning',
                            message: '请选择积分类型'
                        });
                        return;
                    }
                    if(this.point_num==''&&this.point_type==1){
                        this.$message({
                            type: 'warning',
                            message: '请填写增加积分'
                        });
                        return;
                    }
                    if(this.point_num==''&&this.point_type==2){
                        this.$message({
                            type: 'warning',
                            message: '请填写扣减积分'
                        });
                        return;
                    }
                    this.$post(this.global + '/points', {
                        lang: '',
                        per_page: this.pageSize1,
                        page: this.pageNo1,
                        point_type:this.point_type,
                        point_type_sn:this.point_type_sn,
                        option_id:this.option_id,
                        point:this.point_num,
                        staff_sn:this.staff_sn,
                        remarks:this.remarks,
                    }).then(res => {
                        this.loading = false;
                        // this.tableData1 = res.data;
                        // this.totalSize1 = res.meta.total;
                        this.$message({
                            type: 'success',
                            message: res.message
                        });
                        this.getPointsList();
                    }).catch(error=>{
                        this.loading = false;
                        this.$message({
                            type: 'error',
                            message: error.message
                        });
                    });
                    this.dialogFormVisible = false;
                },
                detail2(row) {
                    this.staff_sn = row.staff_sn;
                    this.productData = row;
                    this.productCountDetailDialog = true;
                },
                handleClick(tab) {
                    //console.log(tab.label);
                    if (tab.label == '积分管理'){
                        this.getPointsList();
                    } else {
                        this.getPointsChangeList();
                    }
                    this.start_time = '';
                    this.end_time = '';
                    this.form1.staff_keyword='';
                    this.form1.from_level_id = '';
                    this.form1.status = '';
                    this.pointTypeName2 = '';
                    this.pointsName = '';
                    this.pointsMatterName = '';
                },
                handleSizeChange1(val) {
                    this.pageSize1 = val;
                    this.pageNo1 = 1;
                    this.getPointsList();
                },
                handleCurrentChange1(val){
                    this.pageNo1 = val;
                    this.getPointsList();
                },
                handleSizeChange2(val) {
                    this.pageSize2 = val;
                    this.pageNo2 = 1;
                    this.getPointsChangeList();
                },
                handleCurrentChange2(val){
                    this.pageNo2 = val;
                    this.getPointsChangeList();
                },
                 //获取积分变动记录列表
                getPointsChangeList() {
                    this.loading = true;
                     var  startTime,endTime;
                    if(this.start_time){
                        startTime = this.moment(this.start_time).format("YYYY-MM-DD")
                    }else{
                        startTime = '';
                    }
                    if(this.end_time){
                        endTime = this.moment(this.end_time).format("YYYY-MM-DD");
                    }else{
                        endTime = '';
                    }
                    this.$get(this.global + '/points/logs', {
                        lang: '',
                        per_page: this.pageSize2,
                        page: this.pageNo2,
                        keyword:this.form1.staff_keyword,
                        staff_type_id:this.staff_type_id,
                        start_time:startTime,
                        end_time:endTime,
                        point_type:this.point_type,
                        point_type_sn:this.point_type_sn,
                        option_id:this.option_id,
                    }).then(res => {
                        this.loading = false;
                        // for(var i = 0;i<res.data.length;i++){
                        //     for(var j = 0;j<res.data[i].point_types.length;j++){
                        //         res.data[i][res.data[i].point_types[j].point_type_sn]=res.data[i].point_types[j]
                        //     }
                        // }
                        this.tableData2 = res.data;
                        this.totol_add_point = res.totol_add_point;;
                        this.totol_sub_point = res.totol_sub_point
                        this.totalSize2 = res.meta.total;
                    }).catch(error=>{
                        this.loading = false;
                        console.log(error);
                    });
                },
            },
        created() {
            this.getPointsList();
            this.getPointsTypeList();
            this.getStaffstype();
            this.getPointsChangeList();
        },

    }
</script>

<style lang="scss" scoped>
.container{
  .el-col{
     .moneyInfo{
      text-align: center!important;
      p:nth-child(1){
          font-size: 25px;
          color: red;
          margin-bottom: 18px;
      }
      p:nth-child(3){
          margin-top: 13px;
          color: #529FF0;
          cursor: pointer;
      }
    } 
  }
}
</style>